import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/login.css";
import JoozyLogo from "../../assets/images/joozylogo.png";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const api_url = process.env.REACT_APP_API_URL;

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      Swal.fire({
        title: "Error",
        text: "New password and confirm password do not match.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${api_url}/api/auth/change-password`,
        { oldPassword, newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.fire({
        title: "Success",
        text: "Your password has been changed successfully.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      });
    } catch (error) {
      Swal.fire({
        title: "Change Password Failed!",
        text:
          error.response?.data?.error ||
          "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
    }
  };

  return (
    <div className="login-page d-flex justify-content-center align-items-center">
      <div className="login-card shadow-sm p-5">
        <div className="text-center mb-4">
          <img src={JoozyLogo} alt="Joozy Logo" className="login-logo" />
          <h2 className="login-title">Change Password</h2>
          <p className="login-subtitle">
            Update your password to keep your account secure
          </p>
        </div>

        <form onSubmit={handleChangePassword}>
          <div className="form-floating mb-3">
            <input
              type="password"
              id="oldPassword"
              className="form-control rounded-3 login-input"
              placeholder="Current Password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
            <label htmlFor="oldPassword">Current Password</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="password"
              id="newPassword"
              className="form-control rounded-3 login-input"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <label htmlFor="newPassword">New Password</label>
          </div>

          <div className="form-floating mb-4">
            <input
              type="password"
              id="confirmPassword"
              className="form-control rounded-3 login-input"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <label htmlFor="confirmPassword">Confirm New Password</label>
          </div>

          <button type="submit" className="btn login-btn w-100 fw-bold">
            Change Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;

